import Loader from "react-loader-spinner";
import { Search, CheckLg } from 'react-bootstrap-icons';
import { Table, Modal, Button } from 'react-bootstrap';
import { getProductGroups4Select } from '../store/api/GetAllProduct';
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
const ModalSelectProductGroup = (props) => {
    const name4Search = useRef();
    const selectedItems = useRef([]);
    const { popData, setPopData } = props;
    const { show, onSelect, selectOne, value } = popData;
    const [groupList, setGroupList] = useState([]);

    const close = () => {
        selectedItems.current = [];
        setPopData({ show: false });
        if (onSelect && selectOne) {
            onSelect(null);
        }
    }
    const search = (e) => {
        if (e.key && e.key !== "Enter") {
            return;
        }
        getProductGroups4Select(name4Search.current.value, setGroupList);
    }
    const setSelectedItems = (add, item) => {
        if (add) {
            selectedItems.current.push(item);

        }
        else {
            let indx = selectedItems.current.indexOf(item);
            selectedItems.current.splice(indx, 1);
        }
    }
    const select = () => {
        const array = selectedItems.current.slice();
        selectedItems.current = [];
        if (onSelect) {
            onSelect(array);
            setPopData({ show: false });
        }
    }
    function selectOneRow(row) {
        if (onSelect && selectOne) {
            onSelect(row);
            setPopData({ show: false });
        }
    }
    useEffect(() => {
        if (show) {
            name4Search.current?.focus();
        }
        if (value) {
            name4Search.current.value = value;
        }
    }, [show])
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span> <FontAwesomeIcon icon={faListAlt} size="lg" />&nbsp; انتخاب گروه کالا</span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} /></Modal.Header>
            <Modal.Body className="bodyStyle">
                <div className="form-group col-md-8">
                    <input type="text" className="form-control" ref={name4Search} placeholder="نام گروه کالا" onKeyDown={search} />
                    <Button className="btn-input-tiny" style={{ top: "2px", left: "2px" }} onClick={search}><Search size="22" /></Button>
                </div>
                <Table responsive className="fixedTable mt-2">
                    <thead>
                        <tr>
                            {!selectOne && <th style={{ width: "10%" }}>&nbsp;</th>}
                            <th style={{ width: selectOne ? "50%" : "45%" }}>گروه اصلی</th>
                            <th style={{ width: selectOne ? "50%" : "45%" }}>گروه فرعی</th>

                        </tr>
                    </thead>
                    <tbody>
                        {(groupList === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center", width: "100%" }}>
                                    <Loader type="BallTriangle" color="#bb1370" height={20} width={20} />
                                </td>
                            </tr>
                        }
                        {groupList && Array.isArray(groupList) &&
                            groupList.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => selectOneRow(item)}>
                                    {
                                        !selectOne &&
                                        <td style={{ width: "10%", verticalAlign: "middle" }}>
                                            <input type="checkbox" onChange={(e) => setSelectedItems(e.target.checked, item)} />
                                        </td>
                                    }
                                    <td style={{ width: selectOne ? "50%" : "45%" }}>{item.MainGroupName}</td>
                                    <td style={{ width: selectOne ? "50%" : "45%" }}>{item.GroupName}</td>

                                </tr>
                            )
                        }
                    </tbody>
                </Table>
                <Button variant="info" className="group-Btn" onClick={select}><CheckLg />&nbsp;انتخاب گروه</Button>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectProductGroup;